import { ExchangeCondition } from "../models/ExchangeCondition";
import api from "./api";

export const getExchangeConditions = async (): Promise<ExchangeCondition[]> => {
  try {
    const response = await api.get(`/api/exchangeCondition`);
    return response.data ?? [];
  } catch (error) {
    console.log("error", error);
    return [];
  }
};

export const saveExchangeCondition = async (data: ExchangeCondition) => {
  try {
    const response = await api.post(`/api/exchangeCondition`, data);
    if (!response.data.success) {
      console.log("error", response.data.notifications);
    }
    return response;
  } catch (error) {
    console.log("error", error);
  }
};

export const deleteExchangeCondition = async (id: string) => {
  try {
    const response = await api.delete(`/api/exchangeCondition/${id}`);
    return response;
  } catch (error) {
    console.log("error", error);
  }
};
